import { memo } from 'react';

function CircleTick({ color }: { color: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" fill="none" viewBox="0 0 18 19">
      <path fill={color} d="M9 2a7.5 7.5 0 100 15A7.5 7.5 0 009 2zm0 13.5a6 6 0 110-12 6 6 0 010 12z"></path>
      <path
        fill={color}
        d="M11.025 6.793l-2.835 3.75L6.968 8.96a.75.75 0 10-1.186.922l1.823 2.333a.75.75 0 001.185-.008l3.428-4.5a.755.755 0 00-1.2-.914h.007z"
      ></path>
    </svg>
  );
}

export default memo(CircleTick);
